<template>
  <master-layout>
    <ion-page>
    <br/>
    <br/>
    <div class="ion-padding">
      <div class="alert alert-success">شما از حساب کاربری خود خارج شدید.</div>
    </div>
    <br/>
    <br/>
    <br/>
    </ion-page>
  </master-layout>
</template>

<script>

import { mapActions} from "vuex";
import {IonPage} from "@ionic/vue"
import {useRouter} from 'vue-router';

export default {
  components:{
    IonPage
  },
  mounted()
  {
    this.logoutUser();
    setTimeout(()=>{
      this.$router.replace('/Login')
    },2500)
  },
  setup()
  {
    const router = useRouter();
    return {router};
  },
  methods: {
    ...mapActions("auth", {
      logoutUser: "logoutUser",
    })
  },
};
</script>

<style scoped>
.login-img {
  max-width: 100%;
  width: 200px;
  margin: 0 auto;
}
</style>